import { css } from "@emotion/react";
import React from "react";
import { Button } from "../Button";
import { Modal, ModalProps } from "../Modal";
import { Typography } from "../Typography";

interface ConfirmModalProps extends Partial<ModalProps> {
  title?: string;
  message?: React.ReactNode;
  cancelButtonText: string;
  confirmButtonText: string;
  onCanceled: () => void;
  onConfirmed: () => void;
}
export const ConfirmModal = ({
  title,
  message,
  cancelButtonText,
  confirmButtonText,
  onCanceled,
  onConfirmed,
  onClose,
  ...props
}: ConfirmModalProps) => {
  return (
    <Modal
      css={css`
        width: 100%;
      `}
      header={title ? <Typography variant="h3">{title}</Typography> : undefined}
      body={<div>{message}</div>}
      {...props}
      footer={
        <div
          css={css({
            display: "flex",
            justifyContent: "space-between",
          })}
        >
          <Button
            onClick={() => {
              onCanceled();
              onClose?.();
            }}
            type="button"
            variant="outlined"
            color="primary"
          >
            {cancelButtonText}
          </Button>
          <Button
            onClick={() => {
              onConfirmed();
              onClose?.();
            }}
            type="button"
            variant="filled"
            color="primary"
          >
            {confirmButtonText}
          </Button>
        </div>
      }
    />
  );
};
